// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Js_promise from "../../../../../../../node_modules/rescript/lib/es6/js_promise.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.mjs";
import * as NetworkV2$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/NetworkV2.mjs";
import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.mjs";
import * as NetworkHelper$PorterinFeature from "../../../../shared/core/helpers/NetworkHelper.mjs";
import * as OrderHistoryConfig$PorterinFeature from "./OrderHistoryConfig.mjs";
import * as OrderHistoryHelper$PorterinFeature from "../helpers/OrderHistoryHelper.mjs";
import * as Network$PorterinFusionkitNetworkUtils from "../../../../../../../node_modules/@porterin/fusionkit-network-utils/src/Network.mjs";
import * as ApiUtils$PorterinFusionkitNetworkUtils from "../../../../../../../node_modules/@porterin/fusionkit-network-utils/src/ApiUtils.mjs";
import * as OrderHistoryDataSource$PorterinFeature from "../data-source/OrderHistoryDataSource.mjs";
import * as OrderHistoryRepoConfig$PorterinFeature from "./OrderHistoryRepoConfig.mjs";

function orderHistoryContent(locale) {
  var requestUrl = OrderHistoryDataSource$PorterinFeature.getCMSUrl(locale);
  return Js_promise.then_((function (result) {
                return ApiUtils$PorterinFusionkitNetworkUtils.resolveRepoResponse(function (param) {
                            return Curry._1(OrderHistoryRepoConfig$PorterinFeature.OrderHistoryContentResponseConverter.execute, result);
                          });
              }), Network$PorterinFusionkitNetworkUtils.getRequestV2(requestUrl, undefined, undefined, undefined));
}

function orderHistory(web_tracking_id, auth_token, mobile) {
  var headers = OrderHistoryHelper$PorterinFeature.createAuthenticatedHeaders(web_tracking_id, auth_token, mobile);
  var updatedHeaders = NetworkHelper$PorterinFeature.assignLocaleHeaders(headers);
  return Js_promise.$$catch((function (param) {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: ErrorUtils$Catalyst.getDefaultErrorEntity("Failed to fetch order history", undefined, undefined)
                          });
              }), Js_promise.then_((function (result) {
                    return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                                return Curry._1(OrderHistoryRepoConfig$PorterinFeature.OrderHistoryResponseConverter.execute, result);
                              });
                  }), NetworkV2$Catalyst.get(OrderHistoryConfig$PorterinFeature.order_history, Caml_option.some(updatedHeaders), undefined, undefined, undefined, undefined)));
}

export {
  orderHistoryContent ,
  orderHistory ,
}
/* NetworkV2-Catalyst Not a pure module */
